export default __webpack_public_path__ + "static/media/invitesHeader@2x.3f16d703.png";